/*global _ */
import {name, mixins, props, data} from './config'

export default {
  name,
  mixins,
  props,

  data() {
    return {
      innerValue: this.value,
      isProcessing: false,
      ...data,
    }
  },
  computed: {
    summaryDetails() {
      const items = _.castArray(this.innerValue || [])
      return items.map(item => {
        return {
          title: this.getItemTitle(item),
          quantity: this.getItemQuantity(item),
          price: this.getItemPrice(item),
          subTotal: this.getItemSubTotal(item),
          tax: this.getItemTax(item),
          total: this.getItemTotal(item),
        }
      })
    },
    totals() {
      return _.reduce(this.summaryDetails, (totals, item) => {
        totals.total += item.total
        totals.tax += item.tax
        totals.subTotal += item.subTotal
        return totals
      }, {subTotal: 0, tax: 0, total: 0})
    },
    summaryTitles() {
      const headers = this.header
      return _.mapValues(headers, title => {
        if (_.isString(title)) {
          return {title}
        }
        return title
      })
    },
    summaryHeaders() {
      const headers = this.summaryTitles
      const columns = this.columns
      const order = this.columnsOrder || _.keys(headers)
      return _.reduce(order, (items, key) => {
        const column = columns[key] || {}
        const header = headers[key] || {}
        const attrs = _.merge({}, column.attrs || {}, header.attrs || {})
        const item = {...header, attrs}
        items[key] = item
        return items
      }, {})
    },
    summaryLines() {
      const data = this.summaryDetails
      const columns = this.columns
      const order = this.columnsOrder || _.keys(this.summaryHeaders)
      return data.map(dataItem => {
        return _.reduce(order, (items, key) => {
          const column = columns[key] || {}
          const value = this.formatValue(dataItem[column.key || key], column)
          const item = {attrs: {}, value, ...column}
          items[key] = item
          return items
        }, {})
      })
    },
    summaryFooter() {
      const footer = this.footer
      const order = this.footerOrder || _.keys(footer)
      const totals = this.totals
      return _.reduce(order, (items, key) => {
        const footerItem = footer[key] || {}
        const value = this.formatValue(totals[footerItem.key || key], footerItem)
        const item = {attrs: {}, value, ...footerItem}
        items[key] = item
        return items
      }, {})
    }
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.innerValue = value
      }
    },
  },
  created() {

  },
  methods: {
    formatValue(value, def) {
      if (def && def.format) {
        return this.formatReactiveValues(value, def)
      }
      return value
    },
    getItemTitle(item) {
      return item.attributes.product.title
    },
    getItemQuantity(item) {
      return item.payload.count || 1
    },
    getItemPrice(item) {
      return item.attributes.product.price || 0
    },
    getItemSubTotal(item) {
      return this.getItemPrice(item) * this.getItemQuantity(item)
    },
    getItemTax(item) {
      return item.attributes.product.tax || 0
    },
    getItemTotal(item) {
      return item.total || 0
    },
    emit(value) {
      this.$emit('input', value)
    }
  },
}
